(() => {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
  });
})();
